module.exports = __webpack_public_path__ + "static/media/44684538_2199901423418370_472742398821138432_o.cbfd5a50.jpg";